/*
 * Purpose: My flows list — manage, import, open Map / Mission
 * Last modified: 2026-07-01 | Agent
 * Completeness: 100
 */
import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { WorkflowManager } from '@/components/WorkflowManager';
import { WorkflowCreator } from '@/components/WorkflowCreator';
import { FlowTemplatesSpotlight } from '@/components/dashboard/FlowTemplatesSpotlight';

export default function MyFlowsPage() {
  const [creatorOpen, setCreatorOpen] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <p className="text-sm text-muted-foreground max-w-xl">
          Organize flows, duplicate, import — click a row to open its map, or use Map / Mission.
        </p>
        <Button size="sm" actionTier="primary" onClick={() => setCreatorOpen(true)} className="shrink-0">
          <Plus className="h-4 w-4 mr-1.5" />
          New flow
        </Button>
      </div>

      <FlowTemplatesSpotlight variant="inline" />

      <WorkflowManager />
      <WorkflowCreator open={creatorOpen} onOpenChange={setCreatorOpen} />
    </div>
  );
}
